<template>
  <div class="metric-card">
    <div class="metric-header">
      <h3 class="metric-title">{{ title }}</h3>
      <img :src="iconSrc" class="metric-icon" alt="" />
    </div>

    <div class="metric-content">
      <span class="amount">€{{ formatNumber(amount) }}</span>
      <div class="change" :class="{ 'positive': isPositive(change) }">
        <img
            :src="getChangeIcon(change)"
            class="change-icon"
            alt=""
        />
        <span>{{ change }}%</span>
      </div>
    </div>

    <div class="comparison">
      <span class="comparison-text">Vergeleken met de vorige maand</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { MetricCardProps } from '../types'

export default defineComponent({
  name: 'MetricCard',

  props: {
    title: {
      type: String as PropType<MetricCardProps['title']>,
      required: true
    },
    amount: {
      type: Number as PropType<MetricCardProps['amount']>,
      required: true
    },
    change: {
      type: Number as PropType<MetricCardProps['change']>,
      required: true
    },
    iconSrc: {
      type: String as PropType<MetricCardProps['iconSrc']>,
      required: true
    }
  },

  methods: {
    isPositive(value: number): boolean {
      return value>0
    },

    formatNumber(value: number): string {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    getChangeIcon(change: number): string {
      return this.isPositive(change)
          ? '/assets/arrow-up.svg'
          : '/assets/arrow-down.svg'
    }
  }
})
</script>

<style scoped>
.metric-card {
  border-radius: 12px;
  padding: 8px;
  font-family: Montserrat, sans-serif;
}

.metric-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.metric-title {
  color: var(--Neutral-5, #191a1f);
  font: 500 14px/1 Montserrat, sans-serif;
  margin: 0;
  flex: 1;
}

.metric-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.metric-content {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
}

.amount {
  color: var(--Neutral-5, #191a1f);
  font: 500 16px Montserrat, sans-serif;
}

.change {
  display: flex;
  align-items: center;
  gap: 4px;
  font: 500 10px/1.6 Montserrat, sans-serif;
  color: var(--red-3, #e51a1a);
}

.change.positive {
  color: var(--green-4, #35aa09);
}

.change-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.comparison {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.comparison-text {
  color: var(--Neutral-5, #191a1f);
  font: 400 10px/18px Montserrat, sans-serif;
}
</style>